export const DEWEY_SUBJECT_MAPPING = {
  // 000-099: Computer Science, Knowledge & General Works
  "computer science": "004",
  computer: "004",
  "information systems": "004",
  programming: "005",
  "software engineering": "005.1",
  "data structures": "005.73",
  algorithms: "005.1",
  "software development": "005",
  "operating systems": "005.43",
  javascript: "005.133",
  python: "005.133",
  java: "005.133",
  "c++": "005.133",
  "c#": "005.133",
  php: "005.133",
  ruby: "005.133",
  go: "005.133",
  rust: "005.133",
  typescript: "005.133",
  html: "005.72",
  css: "005.72",
  "web development": "006.7",
  "web design": "006.7",
  "frontend development": "006.7",
  "backend development": "006.7",
  "full stack": "006.7",
  software: "005",
  database: "005.74",
  sql: "005.756",
  mongodb: "005.74",
  postgresql: "005.756",
  mysql: "005.756",
  "artificial intelligence": "006.3",
  "machine learning": "006.31",
  "deep learning": "006.31",
  "neural networks": "006.32",
  "data science": "006.312",
  "computer vision": "006.37",
  "natural language processing": "006.35",
  robotics: "006.3",
  cybersecurity: "005.8",
  "network security": "005.8",
  encryption: "005.82",
  hacking: "005.8",
  "cloud computing": "004.678",
  aws: "004.678",
  azure: "004.678",
  "google cloud": "004.678",
  docker: "005.43",
  kubernetes: "005.43",
  devops: "005.1",
  "version control": "005.1",
  git: "005.1",
  reference: "000",
  "general knowledge": "000",
  encyclopedia: "030",
  periodicals: "050",
  newspapers: "070",
  journalism: "070.4",
  "mass media": "070",
  broadcasting: "070.1",
  internet: "004.678",

  // 100-199: Philosophy & Psychology
  philosophy: "100",
  metaphysics: "110",
  epistemology: "121",
  ethics: "170",
  "moral philosophy": "170",
  logic: "160",
  psychology: "150",
  "cognitive psychology": "153",
  "behavioral psychology": "150.19",
  "developmental psychology": "155",
  "social psychology": "155.9",
  "clinical psychology": "157",
  psychotherapy: "616.89",
  psychiatry: "616.89",
  "mental health": "616.89",
  consciousness: "153",
  perception: "153.7",
  memory: "153.1",
  learning: "153.1",
  motivation: "153.8",
  emotion: "152.4",

  // 200-299: Religion & Theology
  religion: "200",
  theology: "200",
  "comparative religion": "201",
  christianity: "230",
  bible: "220",
  "new testament": "225",
  "old testament": "221",
  catholicism: "282",
  protestantism: "280",
  orthodox: "281",
  islam: "297",
  quran: "297.1",
  judaism: "296",
  torah: "296.1",
  hinduism: "294",
  buddhism: "294.3",
  "eastern religions": "294",
  mythology: "201.3",
  "religious history": "200.9",
  spirituality: "204",

  // 300-399: Social Sciences
  sociology: "301",
  "social theory": "301.01",
  "social problems": "361",
  anthropology: "301",
  "cultural anthropology": "306",
  ethnography: "305.8",
  politics: "320",
  "political science": "320",
  government: "320",
  democracy: "321.8",
  "political theory": "320.01",
  "international relations": "327",
  diplomacy: "327.2",
  "public policy": "320.6",
  economics: "330",
  macroeconomics: "339",
  microeconomics: "338.5",
  finance: "332",
  banking: "332.1",
  investment: "332.6",
  "stock market": "332.63",
  cryptocurrency: "332.4",
  bitcoin: "332.4",
  accounting: "657",
  business: "650",
  management: "658",
  "project management": "658.4",
  leadership: "658.4",
  marketing: "658.8",
  "digital marketing": "658.8",
  "social media marketing": "658.8",
  advertising: "659.1",
  "human resources": "658.3",
  entrepreneurship: "658.11",
  law: "340",
  "constitutional law": "342",
  "criminal law": "345",
  "civil law": "346",
  "international law": "341",
  "intellectual property": "346.048",
  education: "370",
  pedagogy: "371",
  "curriculum development": "375",
  "educational psychology": "370.15",
  "special education": "371.9",
  "higher education": "378",
  customs: "390",
  folklore: "398",

  // 400-499: Language & Linguistics
  linguistics: "410",
  language: "410",
  phonetics: "414",
  grammar: "415",
  semantics: "412",
  "english language": "420",
  "spanish language": "460",
  "french language": "440",
  "german language": "430",
  "italian language": "450",
  "portuguese language": "469",
  "russian language": "491.7",
  "chinese language": "495.1",
  "japanese language": "495.6",
  "arabic language": "492.7",
  "korean language": "495.7",
  "hindi language": "491.4",
  translation: "418",
  "second language acquisition": "418",
  "computational linguistics": "410.285",

  // 500-599: Pure Sciences
  science: "500",
  "natural sciences": "500",
  mathematics: "510",
  arithmetic: "513",
  algebra: "512",
  geometry: "516",
  trigonometry: "516.24",
  calculus: "515",
  "differential equations": "515.35",
  "linear algebra": "512.5",
  "number theory": "512.7",
  "discrete mathematics": "511",
  statistics: "519.5",
  probability: "519.2",
  "data analysis": "519.5",
  physics: "530",
  mechanics: "531",
  thermodynamics: "536",
  optics: "535",
  acoustics: "534",
  electricity: "537",
  magnetism: "538",
  "quantum physics": "530.12",
  "nuclear physics": "539.7",
  "particle physics": "539.72",
  relativity: "530.11",
  astronomy: "523",
  astrophysics: "523.01",
  cosmology: "523.1",
  "solar system": "523.2",
  chemistry: "540",
  "organic chemistry": "547",
  "inorganic chemistry": "546",
  "physical chemistry": "541",
  "analytical chemistry": "543",
  biochemistry: "572",
  "earth sciences": "550",
  geology: "551",
  meteorology: "551.5",
  climate: "551.6",
  "climate change": "551.6",
  oceanography: "551.46",
  biology: "570",
  botany: "580",
  zoology: "590",
  ecology: "577",
  evolution: "576.8",
  genetics: "576.5",
  "molecular biology": "572.8",
  "cell biology": "571.6",
  microbiology: "579",
  "marine biology": "578.77",
  anatomy: "571.3",
  physiology: "571.1",

  // 600-699: Technology & Applied Sciences
  technology: "600",
  "applied sciences": "600",
  medicine: "610",
  "human anatomy": "611",
  "human physiology": "612",
  pathology: "616",
  pharmacology: "615",
  surgery: "617",
  nursing: "610.73",
  dentistry: "617.6",
  veterinary: "636.089",
  "public health": "614",
  epidemiology: "614.4",
  nutrition: "641.1",
  diet: "641.1",
  fitness: "613.7",
  exercise: "613.7",
  "mental disorders": "616.89",
  engineering: "620",
  "mechanical engineering": "621",
  "electrical engineering": "621.3",
  "civil engineering": "624",
  "chemical engineering": "660",
  "biomedical engineering": "610.28",
  "environmental engineering": "628",
  "aerospace engineering": "629.1",
  "computer engineering": "621.39",
  "systems engineering": "005.1",
  agriculture: "630",
  farming: "630",
  "sustainable agriculture": "631.5",
  gardening: "635",
  horticulture: "635",
  "animal husbandry": "636",
  forestry: "634",
  fishing: "639",
  "home economics": "640",
  cooking: "641.5",
  "food science": "641.3",
  baking: "641.81",
  "interior design": "747",
  fashion: "646",
  textiles: "677",
  "child care": "649",
  "personal finance": "332.024",
  "real estate": "333.33",
  construction: "690",
  architecture: "720",
  "urban planning": "711",
  manufacturing: "670",
  "quality control": "658.56",

  // 700-799: Arts & Recreation
  art: "700",
  "fine arts": "700",
  "art history": "709",
  painting: "750",
  drawing: "741",
  sculpture: "730",
  ceramics: "738",
  "graphic design": "741.6",
  illustration: "741.6",
  photography: "770",
  "digital art": "776",
  printmaking: "760",
  "building design": "720",
  music: "780",
  "music theory": "781",
  composition: "781.3",
  "music history": "780.9",
  instruments: "784",
  piano: "786.2",
  guitar: "787.87",
  violin: "787.2",
  singing: "783",
  "music production": "781.49",
  "sound engineering": "621.389",
  theater: "792",
  acting: "792.02",
  directing: "792.02",
  "set design": "792.02",
  film: "791.43",
  "film production": "791.43",
  cinematography: "777",
  animation: "741.58",
  dance: "792.8",
  ballet: "792.84",
  sports: "796",
  athletics: "796.42",
  football: "796.332",
  basketball: "796.323",
  baseball: "796.357",
  soccer: "796.334",
  tennis: "796.342",
  golf: "796.352",
  swimming: "797.2",
  cycling: "796.6",
  "martial arts": "796.8",
  yoga: "613.7046",
  recreation: "790",
  games: "794",
  "board games": "794",
  "video games": "794.8",
  "game development": "794.815",
  hobbies: "790",
  crafts: "745",
  woodworking: "684",
  knitting: "746.43",
  sewing: "646.2",

  // 800-899: Literature & Rhetoric
  literature: "800",
  rhetoric: "808",
  writing: "808",
  "creative writing": "808.3",
  poetry: "811",
  fiction: "813",
  "science fiction": "813.0876",
  fantasy: "813.0876",
  mystery: "813.087",
  romance: "813.085",
  "historical fiction": "813.081",
  drama: "812",
  "short stories": "813.01",
  novels: "813",
  "children literature": "813.009",
  biography: "920",
  autobiography: "920",
  memoir: "920",
  essays: "814",
  "literary criticism": "801",
  "comparative literature": "809",
  "english literature": "820",
  "american literature": "810",
  "world literature": "809",
  "classical literature": "880",
  "news reporting": "070.4",
  "technical writing": "808.066",
  "business writing": "808.066",
  "academic writing": "808.02",
  screenwriting: "808.23",
  playwriting: "808.2",

  // 900-999: History & Geography
  history: "900",
  "world history": "909",
  "ancient history": "930",
  "medieval history": "940.1",
  "modern history": "940",
  "contemporary history": "909.82",
  "american history": "973",
  "european history": "940",
  "asian history": "950",
  "african history": "960",
  "military history": "355.009",
  "social history": "901",
  "cultural history": "901",
  "economic history": "330.9",
  archaeology: "930.1",
  genealogy: "929",
  geography: "910",
  "physical geography": "910",
  "human geography": "304.2",
  cartography: "912",
  "travel guides": "914",
  exploration: "910.4",
  "environmental studies": "304.2",
  "urban studies": "307.76",
  demographics: "304.6",
  "regional studies": "911",
  "life stories": "920",
  "collective biography": "920",
  "individual biography": "920",

  // Additional interdisciplinary and modern subjects
  "data visualization": "001.4226",
  "user experience": "004.019",
  "user interface": "004.019",
  sustainability: "304.2",
  "renewable energy": "333.794",
  "solar energy": "621.47",
  "wind energy": "621.45",
  "nuclear energy": "621.48",
  nanotechnology: "620.5",
  biotechnology: "660.6",
  bioinformatics: "570.285",
  "systems thinking": "003",
  "complexity science": "003.7",
  "network theory": "511.5",
  "game theory": "519.3",
  "decision theory": "658.403",
  "risk management": "658.155",
  "supply chain": "658.7",
  logistics: "658.5",
  "quality assurance": "658.56",
  "continuous improvement": "658.562",
  innovation: "658.57",
  "design thinking": "745.4",
  "service design": "658.812",
  "product design": "745.2",
  "industrial design": "745.2",
  "interaction design": "004.019",
  accessibility: "362.4",
  "inclusive design": "745.4",
  "ethical hacking": "005.8",
  "digital forensics": "363.25",
  "information security": "005.8",
  "privacy protection": "323.448",
  "digital rights": "323.448",
  "artificial general intelligence": "006.3",
  "quantum computing": "004.1",
  "blockchain technology": "005.824",
  "augmented reality": "006.8",
  "virtual reality": "006.8",
  "mixed reality": "006.8",
  "internet of things": "004.678",
  "smart cities": "307.1216",
  "digital transformation": "658.4038",
  "change management": "658.406",
  "organizational behavior": "302.35",
  "cross-cultural communication": "303.482",
  globalization: "303.482",
  "international business": "658.049",
  "social entrepreneurship": "658.408",
  "impact investing": "332.6",
  "circular economy": "330.9",
  "sharing economy": "330.9",
  "gig economy": "331.25",
  "remote work": "658.31",
  "digital nomadism": "331.25",
  "work-life balance": "650.1",
  mindfulness: "158.12",
  meditation: "158.12",
  "positive psychology": "155.232",
  "emotional intelligence": "152.4",
  "cognitive science": "153",
  neuroscience: "612.8",
  "behavioral economics": "330.019",
  "environmental psychology": "155.91",
  "health psychology": "616.0019",
  telemedicine: "610.285",
  "digital health": "610.285",
  "precision medicine": "616.042",
  genomics: "572.86",
  "gene therapy": "615.895",
  immunology: "616.079",
  virology: "579.2",
  "pandemic preparedness": "614.4",
  "disaster management": "363.34",
  "crisis management": "658.4056",
  "business continuity": "658.477",
  "stakeholder management": "658.18",
  "corporate governance": "658.4",
  "business ethics": "174.4",
  "corporate social responsibility": "658.408",
  "diversity and inclusion": "658.3008",
  "unconscious bias": "158.1",
  "cultural competency": "303.482",
  "conflict resolution": "303.69",
  negotiation: "658.4052",
  mediation: "347.09",
  "restorative justice": "364.68",
  "social justice": "303.372",
  "human rights": "323",
  "digital citizenship": "323.448",
  "media literacy": "302.23",
  "information literacy": "028.7",
  "critical thinking": "160",
  "systems design": "003",
  "process improvement": "658.5",
  automation: "670.427",
  "robotic process automation": "670.427",
  "artificial intelligence ethics": "174.90063",
  "algorithmic bias": "174.90063",
  "explainable ai": "006.31",
  "federated learning": "006.31",
  "edge computing": "004.678",
  "serverless computing": "006.76",
  microservices: "004.36",
  "api design": "006.76",
  "database design": "005.756",
  "information architecture": "025.5",
  "content strategy": "658.872",
  "digital marketing analytics": "658.80285",
  "search engine optimization": "658.872",
  "social media strategy": "658.872",
  "influencer marketing": "659.144",
  "brand management": "658.827",
  "customer experience": "658.812",
  "service excellence": "658.812",
  "lean methodology": "658.515",
  "agile methodology": "005.1",
  scrum: "005.1",
  kanban: "658.53",
  "design sprint": "658.575",
  prototyping: "745.2",
  "user research": "658.83",
  "market research": "658.83",
  "competitive analysis": "658.83",
  "business intelligence": "658.472",
  "predictive analytics": "006.312",
  "prescriptive analytics": "006.312",
  "descriptive analytics": "519.5",
};

// Utility function to find classification by subject
export const findDeweyClassification = (subject) => {
  const normalizedSubject = subject.toLowerCase().trim();

  // Direct match
  if (DEWEY_SUBJECT_MAPPING[normalizedSubject]) {
    return DEWEY_SUBJECT_MAPPING[normalizedSubject];
  }

  // Partial match search
  const partialMatches = Object.keys(DEWEY_SUBJECT_MAPPING).filter(
    (key) => key.includes(normalizedSubject) || normalizedSubject.includes(key)
  );

  if (partialMatches.length > 0) {
    return DEWEY_SUBJECT_MAPPING[partialMatches[0]];
  }

  return null;
};

// Utility function to get all subjects in a classification range
export const getSubjectsByRange = (startRange, endRange) => {
  const results = {};

  Object.entries(DEWEY_SUBJECT_MAPPING).forEach(([subject, classification]) => {
    const classNum = parseInt(classification.split(".")[0]);
    if (classNum >= startRange && classNum <= endRange) {
      results[subject] = classification;
    }
  });

  return results;
};

// Utility function to get classification category name
export const getClassificationCategory = (classification) => {
  const classNum = parseInt(classification.split(".")[0]);

  const categories = {
    0: "Computer Science, Knowledge & General Works",
    1: "Philosophy & Psychology",
    2: "Religion & Theology",
    3: "Social Sciences",
    4: "Language & Linguistics",
    5: "Pure Sciences",
    6: "Technology & Applied Sciences",
    7: "Arts & Recreation",
    8: "Literature & Rhetoric",
    9: "History & Geography",
  };

  const categoryIndex = Math.floor(classNum / 100);
  return categories[categoryIndex] || "Unknown Category";
};

// Utility function to search subjects by keyword
export const searchSubjects = (keyword) => {
  const normalizedKeyword = keyword.toLowerCase().trim();
  const results = {};

  Object.entries(DEWEY_SUBJECT_MAPPING).forEach(([subject, classification]) => {
    if (subject.includes(normalizedKeyword)) {
      results[subject] = classification;
    }
  });

  return results;
};
